exports.onRouteUpdate = () => {
  // Scroll to the top of the page on route update
  if (typeof window !== "undefined") {
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
  }
};
